var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"issue-epss-table-cell column"},[(_vm.hasEPSS)?_c('epss-score',{staticClass:"issue-epss-table-cell__data",attrs:{"value":_vm.getEPSS}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }